// loadCampaignFromUrlQuery.js
'use strict';

import { ADD_MESSAGE } from '../ActionTypes.js';
import getMeData from '../selector/getMeData.js';
import login from '../action/login.js';
import openBindEmailModal from '../action/openBindEmailModal.js';
import addModal from '../action/addModal.js';
import openRecommendDiamondPackSelector from '../action/openRecommendDiamondPackSelector.js';
import addPendingRemoveSearchParams from '../action/addPendingRemoveSearchParams.js';
import setOperationChatroomData from '../action/setOperationChatroomData.js';
import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import setUsingGameId from '../action/setUsingGameId.js';
import { decodeUnicode } from '../resource/base64Utils.js';
import { push as customerServicePush } from '../resource/customerService.js';
import updateRegisterData from '../action/updateRegisterData.js';

/**
 * Load campaign from url query
 * @kind action
 * @param {URLSearchParams} {searchParams} - search parameters.
 * @return {Promise} Action promise.
 */
const loadCampaignFromUrlQuery =
  ({ searchParams }) =>
  async (dispatch, getState) => {
    const campaignId = searchParams.get('campaign-id');
    const meId = getMeData(getState(), 'id');

    let campaign;

    if (searchParams.get('campaign')) {
      campaign = JSON.parse(
        decodeUnicode({ str: searchParams.get('campaign') })
      );
    }

    if (campaignId === 'dailylogin') {
      const isEmailBound = getMeData(getState(), 'isEmailBound');
      if (!meId) {
        dispatch(login());
      } else if (!isEmailBound) {
        dispatch(
          openBindEmailModal({
            canClose: true,
          })
        );
      } else {
        dispatch(addModal({ id: 'BackpackModal' }));
      }
    } else if (campaignId === 'intercom-show') {
      customerServicePush({ args: ['show'] });
    } else if (campaignId === 'intercom-show-messages') {
      customerServicePush({ args: ['showMessages'] });
    } else if (campaignId === 'intercom-show-new-message') {
      customerServicePush({ args: ['showNewMessage', campaign] });
    } else if (campaignId === 'intercom-send-event') {
      customerServicePush({
        args: ['trackEvent', campaign.eventName, campaign.metadata],
      });
    } else if (campaignId === 'open-modal' && campaign.modalId) {
      dispatch(addModal({ id: campaign.modalId, isHigherThanAll: true }));
    } else if (campaignId === 'logged-checkout-diamondpack') {
      const meId = getMeData(getState(), 'id');
      if (!meId) {
        dispatch(login());
      } else {
        const currency = campaign?.currency?.toUpperCase?.();
        const productIds = campaign?.ids;
        const categories = campaign?.categories;
        const recommendProductId = campaign?.default_id;
        dispatch(
          openRecommendDiamondPackSelector({
            productIds,
            categories,
            via: 'notification',
            currency,
            recommendProductId,
          })
        );
      }
    } else if (campaignId === 'checkout-diamondpack') {
      const currency = campaign?.currency?.toUpperCase?.();
      const productIds = campaign?.ids;
      const categories = campaign?.categories;
      const recommendProductId = campaign?.default_id;
      dispatch(
        openRecommendDiamondPackSelector({
          productIds,
          categories,
          via: 'notification',
          currency,
          recommendProductId,
        })
      );
    } else if (campaignId === 'auto-message-v2') {
      const messageId = campaign?.id;
      dispatch({
        type: ADD_MESSAGE,
        payload: {
          ...(campaign || {}),
          senderId: campaign?.sender,
          postedAtUnix: campaign?.postedAt,
        },
      });
      dispatch(
        setOperationChatroomData({
          key: 'replyMessageId',
          payload: {
            replyMessageId: messageId,
          },
        })
      );
    } else if (campaignId === 'open-game-menu') {
      dispatch(setLiveStreamPanel({ isGamePanelOpen: true }));
    } else if (campaignId === 'open-livestream-gift-modal') {
      dispatch(setLiveStreamPanel({ isGiftPanelOpen: true }));
      dispatch(
        addModal({
          id: 'LiveStreamGiftModal',
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
    } else if (campaignId === 'open-game') {
      if (!meId) {
        dispatch(login());
      } else {
        const gameId = campaign?.gameId;
        dispatch(setLiveStreamPanel({ isGameOpen: true }));
        dispatch(setUsingGameId({ gameId }));
      }
    } else if (campaignId === 'change-phone-number') {
      dispatch(
        updateRegisterData({ dataKey: 'isChangePhoneNumber', value: true })
      );
      dispatch(addModal({ id: 'LoginPhone', isHigherThanAll: true }));
    }

    // Remove search param at the same time
    if (campaignId) {
      dispatch(
        addPendingRemoveSearchParams({
          queryKeys: ['campaign', 'campaign-id'],
        })
      );
    }

    return dispatch({ type: '' });
  };

export default loadCampaignFromUrlQuery;
